import { call, put } from "redux-saga/effects";
import { API_URL, ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getCountries(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.COUNTRIES, action.payload, true);
}

export function* getStates(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.COMMON.STATES + "/" + action.payload.countryId + "/" + action.payload.type,
    null,
    true,
  );
}

export function* getCities(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.CITIES + "/" + action.payload.stateId, null, true);
}

export function* contactUs(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.CONTACTUS, action.payload, true);
}

export function* contactSupport(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.CONTACT_SUPPORT, action.payload, true);
}

export function* getSEOList(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.SEO_LIST }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.SEO_LIST, action.payload, true, yieldPuts);
}
export function* getGameDetails(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.GAME_DETAILS, payload: "game_details" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.GAME_DETAILS, null, true, yieldPuts);
}

export function* getLanguages(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.LANGUAGES, payload: "languages" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.LANGUAGES, action.payload, true, yieldPuts);
}

export function* getWorkPlaces(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.WORK_PLACES, payload: "work_places" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.WORK_PLACES, action.payload, true, yieldPuts);
}

export function* getJobPostTypes(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.JOB_POST_TYPES, payload: "job_post_types" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.JOB_POST_TYPES, action.payload, true, yieldPuts);
}

export function* getSkills(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.SKILLS, payload: "skills" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.SKILLS, action.payload, true, yieldPuts);
}

export function* getIndustries(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.INDUSTRIES, payload: "industries" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.INDUSTRIES, action.payload, true, yieldPuts);
}

export function* getNationalities(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.NATIONALITIES, payload: "nationalities" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.NATIONALITIES, action.payload, true, yieldPuts);
}

export function* getCountriesNew(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.COUNTRIES_NEW, payload: "countries" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.COUNTRIES_NEW, action.payload, true, yieldPuts);
}

export function* getStatesNew(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.STATES_NEW, payload: "states" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.STATES_NEW, action.payload, true, yieldPuts);
}

export function* getCitiesNew(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.CITIES_NEW, payload: "cities" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.CITIES_NEW, action.payload, true, yieldPuts);
}

export function* getCurrencies(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.CURRENCIES, payload: "currencies" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.CURRENCIES, action.payload, true, yieldPuts);
}

export function* getSalaryRanges(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.SALARY_RANGES, payload: "salary_ranges" }];

  // Build URL with query parameters
  const { currency_code, limit = 30, offset = 0 } = action.payload || {};
  let apiUrl = API_URL.COMMON.SALARY_RANGES;

  if (currency_code) {
    apiUrl += `?currency_code=${currency_code}&limit=${limit}&offset=${offset}`;
  } else {
    apiUrl += `?limit=${limit}&offset=${offset}`;
  }

  console.log("Salary Ranges API URL:", apiUrl);

  yield call(sagaFunction, action, CallApi.GET, apiUrl, null, true, yieldPuts);
}

export function* getFunctionalAreas(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.FUNCTIONAL_AREAS, payload: "functional_areas" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.FUNCTIONAL_AREAS, action.payload, true, yieldPuts);
}

export function* getDesignations(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.DESIGNATIONS, payload: "designations" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.DESIGNATIONS, action.payload, true, yieldPuts);
}

export function* getEducationLevels(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.EDUCATION_LEVELS, payload: "education_levels" }];

  // Build URL with query parameters
  const { limit = 30, offset = 0 } = action.payload || {};
  const apiUrl = `${API_URL.COMMON.EDUCATION_LEVELS}?limit=${limit}&offset=${offset}`;

  console.log("Education Levels API URL:", apiUrl);

  yield call(sagaFunction, action, CallApi.GET, apiUrl, null, true, yieldPuts);
}

export function* getJobTitleSuggestions(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.JOB_TITLE_SUGGESTIONS, payload: "" }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.JOB_TITLE_SUGGESTIONS, action.payload, true, yieldPuts);
}

export function* enhanceText(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.ENHANCE_TEXT, action.payload, true);
}

export function* generateJobDescriptionSkills(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.GENERATE_JOB_DESCRIPTION_SKILLS, action.payload, true);
}

export function* sendOfferLetterFile(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.OFFER_LETTER.SEND_FILE, action.payload, true);
}

export function* sendOfferLetter(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.OFFER_LETTER.SEND, action.payload, true);
}

export function* generateOfferLetter(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.OFFER_LETTER.GENERATE, action.payload, true);
}

export function* updateCounterOfferStatus(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.POST,
    API_URL.OFFER_LETTER.UPDATE_COUNTER_OFFER_STATUS,
    action.payload,
    true,
  );
}

export function* getPendingActions(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.OFFER_LETTER.PENDING_ACTIONS, action.payload, true);
}
